<template>
  <div>
    <v-tabs class="mt-0">
      <v-tab class="font-weight-bold" @click="setSelectedTab('-created_at')">新着順</v-tab>
      <v-tab class="font-weight-bold" @click="setSelectedTab('-lgtm_count')">人気順</v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "TopicSortTabs",
  methods: {
    setSelectedTab(column) {
      this.$emit("selectedTab", column);
    },
  },
};
</script>
